// extracted by mini-css-extract-plugin
export default {"wrapper":"Gea","container":"Hea","title":"Iea","desc":"Jea","usage":"Kea","box":"Lea","subtitle":"Mea","ingredients":"Nea","carousel":"Oea","ingredientscarousel":"Pea","productinfo":"Qea","ingredientsinfo":"Rea"};
    if(module.hot) {
      // 1737143665393
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  